export default function (state = [], action={}) {
    switch (action.type) {
    case "GET_KASM_REQUESTED":
        return {
            ...state,
            getKasmLoading: true,
            getKasmError: null
        };
    case "GET_KASM_SUCCESS":
        return {
            ...state,
            kasms: action.response.kasms,
            current_time: action.response.current_time,
            getKasmLoading: false,
            getKasmError: null,
        };
    case "GET_KASM_FAILED":
        return {
            ...state,
            getKasmLoading: false,
            getKasmError: action.response
        };

    case "GET_KASM_ID_REQUESTED":
        return {
            ...state,
            getKasm_IdLoading: true,
            getKasm_IdError: null
        };
    case "GET_KASM_ID_SUCCESS":
        return {
            ...state,
            kasm: action.response.kasm,
            getKasm_IdLoading: false,
            getKasm_IdError: null,
        };
    case "GET_KASM_ID_FAILED":
        return {
            ...state,
            getKasm_IdLoading: false,
            getKasm_IdError: action.response
        };

    default:
        return state;
    }
}